"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompositionStatus = void 0;
var CompositionStatus;
(function (CompositionStatus) {
    CompositionStatus["ACTIVE"] = "ACTIVE";
    CompositionStatus["INACTIVE"] = "INACTIVE";
})(CompositionStatus || (exports.CompositionStatus = CompositionStatus = {}));
//# sourceMappingURL=composition.js.map